<template>
  <div ref="component" class="cx_style deng">
    <p v-if="title.length >= 1" :style="getTitleStyle" class="mb8 option_name font14">
      {{ title }}
    </p>
    <div class="verticallyCenterAround" :style="getLineStyle">
      <div class="line_setting_select">
        <el-select
          placeholder="请选择"
          :value="chineseLineName"
          :class="lineNameAsync"
          @change="changeEv"
          class="inlineMiddle"
          ref="borderStyleSelect"
        >
          <el-option v-for="(item1, index1) in borderStyleList" :key="index1" :label="item1.value" :value="item1.value">
            <div
              class="select-tag"
              :style="{
                backgroundImage: 'url(' + item1[request_prefix + 'Src'] + ')',
                height: '16px'
              }"
            ></div>
          </el-option>
        </el-select>
      </div>
      <div class="number-input-box ml8" style="width: 80px">

        <single-input
          class="percent100"
          :value.sync="lineWidthAsync"
          inputSuffixs="px"
        />
      </div>
      <div
        class="color-picker-container inlineMiddle ml8 color_picker_box"
        v-if="lineColor && checkType(lineColorAsync)"
      >
        <el-color-picker
          class=""
          size="small"
          v-model="lineColorAsync"
          :show-alpha="true"
          :predefine="predefineColors"
          @active-change="activeChangeColor"
        ></el-color-picker>
      </div>
    </div>
  </div>
</template>

<script>
import publicData from "../mixins/publicData.js"
export default {
  name: "lineSetting",
  mixins: [publicData],

  props: {
    lineName: {
      type: String,
      required: true
    },
    lineWidth: {
      type: Number,
      required: true
    },
    lineColor: {
      type: String,
      required: false
    },
    title: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      this1: this,
      chineseLineName: undefined,
      mounted: false
    }
  },
  computed: {
    lineNameAsync: {
      get() {
        return this.lineName
      },
      set(val) {
        this.$emit("update:lineName", val)
      }
    },
    lineWidthAsync: {
      get() {
        return this.lineWidth
      },
      set(val) {
        this.$emit("update:lineWidth", Number(val))
      }
    },
    lineColorAsync: {
      get() {
        return this.lineColor
      },
      set(val) {
        this.$emit("update:lineColor", val)
      }
    },
    getTitleStyle() {
      return {
        fontSize: "14px"
      }
    },
    getLineStyle() {
      if (this.mounted) {
        if (this.request_prefix  === "bigScreen") {
          return {
            "--selectHeight": "8px"
          }
        } else {
          return {
            "--selectHeight": "6px"
          }
        }
      } else return {}
    }
  },
  mounted() {
    this.$nextTick(() => {})
    this.init()
    this.mounted = true
  },
  methods: {
    init() {
      requestAnimationFrame(() => {
        const title = this.$refs.title
        const box = this.$refs.component
        if (box && box.offsetWidth) {
          this.changeLineName()
        } else {
          this.init()
        }
      })
    },
    changeLineName() {
      //1，input框文字处理逻辑
      const item = this.borderStyleList.find(it => it.value === this.lineNameAsync)
      const _chineseLineName = item.title //获取边线的中文名
      const inputInner = this.$refs.borderStyleSelect.$el.getElementsByClassName("el-input__inner")[0] //input框的dom
      const inputWidth = inputInner.offsetWidth //input框宽度
      const computedStyle = window.getComputedStyle(inputInner)
      const inputFontSize = Number(computedStyle.getPropertyValue("font-size").slice(0, -2)) //iinput框的fontsize
      const textWidth = _chineseLineName.length * inputFontSize //文字宽度
      this.chineseLineName = _chineseLineName //修改input框的value，这个value由空格和文字组成
      //-----------------------input框文字逻辑处理完毕
      //2.input框的背景图（线条图）处理逻辑
      inputInner.style.backgroundImage = "url(" + item[this.request_prefix + "Src"] + ")"
      //4表示的是文字和背景图的右边距，8代表箭头右边距，16表示的是箭头
      inputInner.style.backgroundPosition = `-${216 - inputWidth + textWidth + 4 + 8 + 16}px center`
    },
    changeEv(val) {
      this.lineNameAsync = val
      this.$nextTick(() => {
        this.changeLineName()
      })
    },
    getFocus(event) {
      event.currentTarget.select()
    },
    activeChangeColor(val) {
      this.lineColorAsync = val
    }
  }
}
</script>

<style scoped>
.color_picker_box {
  width: 32px;
  height: 32px;
}
.line_setting_select {
  border-radius: 4px;
  /* border: var(--inputBorder) !important; */
  width: 100px;
}

::v-deep.el-select .el-input .el-input__inner {
  text-align: right;
  padding-right: 28px;
  display: block;
  border: none !important;
  background-repeat: no-repeat;
  background-clip: content-box;
}
.el-select {
  background: var(--inputBackGround) !important;
  border-radius: 4px;
}
.number-input-box/deep/ .el-input__inner:hover {
  background: var(--inputNuberHoverThemeBgColor) !important;
}
.option_name{
  color:var(--text)
}
</style>
